import React from 'react';
import BZPopover from '../../../../../web-common/bizzabo-components/components/BZPopover';
import PlayIconFilledIcon from '@bizzabo/icons/dist/PlayIconFilledIcon';
import LoginPopover from './LoginPopover';
import NoAccessToVirtualSessionPopover from './NoAccessToVirtualSessionPopover';
import {
    sendCustomClick
} from '../../../utils/SnowplowUtils';
import {
    buttonTypes,
    watchOnDemandSubCategory
} from '../../../constants/SnowplowConst';

const PlayButtonWithSessionAccessControl = ({
    isAuthenticated,
    sessionAccessError,
    setSessionAccessError,
    showEmailLogin,
    eventUrls,
    setLoginV2OffsetTop,
    siteConf,
    playProps,
    analyticData,
}) => {
    const onClickIconHandler = (withPlayProps) =>
        (e) => {
            sendCustomClick(buttonTypes.watchOnDemandButton, watchOnDemandSubCategory, e.currentTarget);
            withPlayProps && playProps?.onClick?.();
        };

    return (
        <div className="broadcast-record-play-icon">
            {
                !isAuthenticated && !sessionAccessError &&
                <BZPopover
                    placement='bottom'
                    cls="need-login-popover"
                    button={<PlayIconFilledIcon fontSize='89px' fill='#fff' onClick={onClickIconHandler()}/>}
                    popover={<LoginPopover
                        onLoginClick={showEmailLogin}
                        eventUrls={eventUrls}
                        setLoginV2OffsetTop={setLoginV2OffsetTop}
                        isWidget={siteConf?.isWidget}
                        analyticData={analyticData}
                    />}
                />
            }
            {
                isAuthenticated &&
                !sessionAccessError &&
                <PlayIconFilledIcon fontSize='89px' fill='#fff' onClick={onClickIconHandler(true)} />
            }
            {
                sessionAccessError &&
                <BZPopover
                    placement='bottom'
                    cls="no-access-to-session-popover"
                    defaultOverlayShown
                    onHide={() => setSessionAccessError(null)}
                    button={<PlayIconFilledIcon fontSize='89px' fill='#fff' onClick={onClickIconHandler()}/>}
                    popover={<NoAccessToVirtualSessionPopover sessionAccessError={sessionAccessError}/>}
                />
            }
        </div>);
};

export default PlayButtonWithSessionAccessControl;
